import { cloneDeep } from 'lodash';

export const serializeFormValues = (values: any) => {
  const valuesCopy = cloneDeep(values);

  // On the POST request, we don't want the temporary document ids nor draft documents
  valuesCopy.documents = valuesCopy.documents?.filter(doc => !!doc.url);
  valuesCopy.documents?.forEach(document => {
    if (document.id.indexOf('new-') == 0) {
      delete document.id;
    }
  });

  return valuesCopy;
};
